import { render, staticRenderFns } from "./FormGuideSelectionStats.vue?vue&type=template&id=36d3e373"
import script from "./FormGuideSelectionStats.vue?vue&type=script&lang=js"
export * from "./FormGuideSelectionStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports